export const MODULE_IDS = {
  MAP: "map",
  ANALYTICS: "analytics",
  TRENDS: "trends",
  CANDIDATES: "candidates",
  LANDMARKS: "landmarks",
  REPORTS: "reports",
  TSUNAMI: "tsunami",
  EDUCATION: "education",
  QUARTERS: "quarters",
  TESTING: "testing",
  ADMIN: "admin",
  SETTINGS: "settings",
};

export const APP_MODULES = [
  {
    id: MODULE_IDS.MAP,
    label: "Mapa",
    path: "/app",
    navGroup: "core",
    navOrder: 10,
    description:
      "Základní přehled a porovnání výsledků na úrovni jednotlivých okrsků. Zvolte strany a volby, které chcete porovnat.",
  },
  {
    id: MODULE_IDS.ANALYTICS,
    label: "Analytika",
    path: "/app/analytics/overview",
    navGroup: "core",
    navOrder: 20,
    moduleKey: "analytics",
    accessFlag: "canAccessAnalytics",
    adminToggle: true,
    description:
      "Detailní přehled jedné volby a jedné strany včetně výsledků, velikosti okrsků a volební účasti.",
  },
  {
    id: MODULE_IDS.TRENDS,
    label: "Trendy",
    path: "/app/trends",
    navGroup: "core",
    navOrder: 30,
    moduleKey: "trends",
    accessFlag: "canAccessTrends",
    adminToggle: true,
    description:
      "Sestavte analytický dotaz nad KV nebo PSP a porovnejte změny po okrscích v mapě i tabulkách.",
  },
  {
    id: MODULE_IDS.CANDIDATES,
    label: "Kandidáti",
    path: "/app/candidates",
    navGroup: "core",
    navOrder: 40,
    moduleKey: "candidates",
    accessFlag: "canAccessCandidates",
    adminToggle: true,
    description:
      "Porovnávejte kandidátské hlasy a rozdíly mezi kandidáty po jednotlivých okrscích.",
  },
  {
    id: MODULE_IDS.LANDMARKS,
    label: "Místa",
    path: "/app/landmarks",
    navGroup: "core",
    navOrder: 50,
    moduleKey: "landmarks",
    accessFlag: "canAccessLandmarks",
    adminToggle: true,
    description:
      "Zobrazte orientační body a vrstvy míst nad volební mapou aktuální oblasti.",
  },
  {
    id: MODULE_IDS.REPORTS,
    label: "Reporty",
    path: "/app/reports",
    navGroup: "core",
    navOrder: 60,
    moduleKey: "reports",
    accessFlag: "canAccessReports",
    adminToggle: true,
    description:
      "Spravujte uložené analytické snapshoty a skládejte je do PDF reportů.",
  },
  {
    id: MODULE_IDS.TSUNAMI,
    label: "Tsunami",
    path: "/app/tsunami",
    navGroup: "core",
    navOrder: 35,
    moduleKey: "tsunami",
    accessFlag: "canAccessTsunami",
    adminToggle: true,
    description:
      "Sledujte pořadí stran nebo kandidátů po okrscích a rychle odhalte lokální výkyvy.",
  },
  {
    id: MODULE_IDS.EDUCATION,
    label: "Školství",
    path: "/app/education",
    navGroup: "other",
    navOrder: 20,
    moduleKey: "education",
    accessFlag: "canAccessEducation",
    adminToggle: true,
    description:
      "Prohlížejte investice a školská zařízení v aktuální oblasti podle filtrů, mapy a tabulek.",
  },
  {
    id: MODULE_IDS.QUARTERS,
    label: "Čtvrti",
    path: "/app/quarters",
    navGroup: "other",
    navOrder: 30,
    moduleKey: "quarters",
    accessFlag: "canAccessQuarters",
    adminToggle: true,
    description:
      "Pracovní prostor pro čtvrťové pohledy a budoucí area-specific analýzy.",
  },
  {
    id: MODULE_IDS.TESTING,
    label: "Testing",
    path: "/app/testing",
    navGroup: "other",
    navOrder: 40,
    moduleKey: "testing",
    accessFlag: "canAccessTesting",
    adminToggle: true,
    description:
      "Bezpečný prostor pro ověřování nových frontendových pohledů před zařazením do hlavních modulů.",
  },
  {
    id: MODULE_IDS.ADMIN,
    label: "Admin",
    path: "/app/admin",
    navGroup: "admin",
    navOrder: 100,
    description:
      "Správa žádostí, pozvánek, uživatelů, voleb a modulových oprávnění.",
  },
  {
    id: MODULE_IDS.SETTINGS,
    label: "Nastavení",
    path: "/app/settings",
    navGroup: "utility",
    navOrder: 110,
    description:
      "Základní informace o účtu, aktuální oblasti a dostupných oblastech.",
  },
];

export const ADMIN_MODULE_OPTIONS = APP_MODULES.filter((module) => module.adminToggle).map((module) => ({
  key: module.moduleKey,
  label: module.label,
}));

export const MODULE_LABELS = APP_MODULES.reduce((labels, module) => {
  if (module.moduleKey) labels[module.moduleKey] = module.label;
  labels[module.id] = module.label;
  return labels;
}, {});

export const REAL_MODULE_KEYS = ADMIN_MODULE_OPTIONS.map((module) => module.key);

export function isRealModuleKey(key) {
  return REAL_MODULE_KEYS.includes(String(key || ""));
}

export function getModuleById(id) {
  return APP_MODULES.find((module) => module.id === id) || null;
}

export function getModuleByPath(path) {
  const currentPath = String(path || "");
  return (
    APP_MODULES.find((module) => {
      if (!module.path) return false;
      if (module.path === "/app") return currentPath === "/app" || currentPath === "/app/welcome";
      return currentPath === module.path || currentPath.startsWith(`${module.path}/`);
    }) || null
  );
}

export function getModuleLabel(key) {
  return MODULE_LABELS[String(key || "")] || String(key || "");
}

export function filterRealModuleKeys(keys) {
  if (!Array.isArray(keys)) return [];
  return keys.filter(isRealModuleKey);
}
